import AccountTypes from '../../../constants/AccountTypes'

const encryptEcheck = ({
  modulus, exponent, bankRoutingNumber,
  accountNumber, accountName, accountType,
  postalCode, stateProvince,
}) => {
  const { AMS } = window
  if (AMS) {
    const accountInfo = new AMS.AccountInfo()
    accountInfo.setModulus(modulus)
    accountInfo.setExponent(exponent)

    if (bankRoutingNumber) {
      accountInfo.setBankID(`${bankRoutingNumber}`)
    }

    if (accountNumber) {
      accountInfo.setAccountNumber(`${accountNumber}`)
    }

    if (accountName) {
      accountInfo.setAccountOwner(`${accountName}`)
    }

    if (AccountTypes[accountType]) {
      accountInfo.setAccountType(AccountTypes[accountType])
    }

    if (postalCode) {
      accountInfo.setZip(`${postalCode}`)
    }

    if (stateProvince) {
      accountInfo.setState(`${stateProvince}`)
    }

    return AMS.getCipher(accountInfo)
  }
  return 'No AMS object founded'
}

const encryptEUDD = ({
  modulus, exponent, bankCountryCode, bicCode, iban, accountName, postalCode,
}) => {
  const { AMS } = window
  if (AMS) {
    const accountInfo = new AMS.AccountInfo()
    accountInfo.setModulus(modulus)
    accountInfo.setExponent(exponent)

    if (bankCountryCode) {
      accountInfo.setCustomerBankCountryCode(`${bankCountryCode}`)
    }

    if (bicCode) {
      accountInfo.setCustomerBankSortCode(`${bicCode}`)
    }

    if (iban) {
      accountInfo.setAccountNumber(`${iban}`)
    }

    if (accountName) {
      accountInfo.setAccountOwner(`${accountName}`)
    }

    accountInfo.setAccountType('c')

    if (postalCode) {
      accountInfo.setZip(`${postalCode}`)
    }

    return AMS.getCipher(accountInfo)
  }
  return 'No AMS object founded'
}

export {
  encryptEcheck,
  encryptEUDD,
}
